import {Box, Button, Card, CardContent, Typography} from "@mui/material";

import {useLogInMutation} from "./api";
import useForm from "hooks/useForm";
import {FC} from "react";
import PhoneInput, {validatePhone} from "./PhoneInput";
import PasswordInput, {validatePassword} from "./PasswordInput";
import {setAtom} from "utils/atom";
import {userAtom} from "../user";

const Login: FC = () => {
  const [logIn, {loading: loggingIn}] = useLogInMutation();

  const {fields, handleSubmit} = useForm({
    fields: {
      phone: ["", validatePhone],
      password: ["", validatePassword],
    },
    onSubmit: values => logIn(values).then(user => setAtom(userAtom, user)),
  });

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px={2}>
      <Card
        component="form"
        onSubmit={handleSubmit}
        sx={{maxWidth: 400, width: "100%"}}
        elevation={0}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>
            Sign in to your account
          </Typography>

          <PhoneInput {...fields.phone} />
          <PasswordInput {...fields.password} />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            loading={loggingIn}
            loadingPosition="start"
            sx={{mt: 3}}>
            {loggingIn ? "Signing In..." : "Sign In"}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
